import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import "./Navbar.css";

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => setMenuOpen(!menuOpen);

  return (
    <nav className="navbar">
      <div className="logo">DevBrows</div>

      {/* <button className="hamburger" onClick={toggleMenu}>
        &#9776;
      </button>

      <div className={`nav-tabs ${menuOpen ? "open" : ""}`}>
        <NavLink to="/" className={({ isActive }) => isActive ? "active" : ""}>
          Home
        </NavLink>
        <NavLink to="/about" className={({ isActive }) => isActive ? "active" : ""}>
          About Us
        </NavLink>
        <NavLink to="/team" className={({ isActive }) => isActive ? "active" : ""}>
          Team
        </NavLink>
        <NavLink to="/pricing" className={({ isActive }) => isActive ? "active" : ""}>
          Pricing
        </NavLink>
        <NavLink to="/contact" className={({ isActive }) => isActive ? "active" : ""}>
          Contact
        </NavLink>
      </div> */}

<div className="nav-right">
  <button className="hamburger" onClick={toggleMenu}>
    &#9776;
  </button>

  <div className={`nav-tabs ${menuOpen ? "open" : ""}`}>
    <NavLink to="/" onClick={() => setMenuOpen(false)} className={({ isActive }) => isActive ? "active" : ""}>
      Home
    </NavLink>
    <NavLink to="/about" onClick={() => setMenuOpen(false)} className={({ isActive }) => isActive ? "active" : ""}>
      About Us
    </NavLink>
    <NavLink to="/team" onClick={() => setMenuOpen(false)} className={({ isActive }) => isActive ? "active" : ""}>
      Team
    </NavLink>
    <NavLink to="/pricing" onClick={() => setMenuOpen(false)} className={({ isActive }) => isActive ? "active" : ""}>
      Pricing
    </NavLink>
    <NavLink to="/contact" onClick={() => setMenuOpen(false)} className={({ isActive }) => isActive ? "active" : ""}>
      Contact
    </NavLink>
  </div>
</div>
    </nav>
  );
};

export default Navbar;
